<template>
	<div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalCurriculum" ref="modalCurriculum" dialog-class="modal-full" title="Curriculum" scrollable>
      <curriculum :curriculum="curriculumItem"></curriculum>
      <template slot="modal-footer">
          <b-button variant="secondary" @click="hideModalCurriculum">Close</b-button>
      </template>
    </b-modal>
    <b-card>
      <b-card-title>
        <div class="row">
          <b-col xs="12" sm="6" md="6" lg="6" xl="6">
            Search CVs
          </b-col>
        </div>
      </b-card-title>
        <b-form @submit.prevent="searchAll">
          <div class="row">
            <b-col xs="12" sm="6" md="6" lg="6" xl="6">
              <div class="form-group">
                <label>Name</label>   
                <div class="input-group"> 
                  <b-form-input v-model="formSearch.name"></b-form-input>
                </div>
              </div>
            </b-col>
            <b-col xs="12" sm="6" md="6" lg="6" xl="6">
              <div class="form-group">
                <label>E-mail</label>   
                <div class="input-group"> 
                  <b-form-input v-model="formSearch.email"></b-form-input>
                </div>
              </div>
            </b-col>
          </div>
          <div class="row">
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <b-button type="submit" variant="primary"><i class="fas fa-search"></i> Search</b-button>
            </b-col>
          </div>
        </b-form>
      <div class="mt-3">
        <b-card-title>
          <div class="row">
            <b-col xs="12" sm="6" md="6" lg="6" xl="6">
              Searched CVs
            </b-col>
          </div>
        </b-card-title>
        <div v-if="searchResult.length === 0" class="alert alert-info">No results found for this criteria.</div>
        <div v-else>
          <b-table responsive show-empty hover :items="searchResult" :fields="searchResultFields" :current-page="currentPage" :per-page="0">
            <template v-slot:cell(edit)="row">
              <b-button v-b-tooltip.hover title="View curriculum" variant="info" size="xs" class="ml-1" @click="viewCurriculum(row.item)"><i class="fa fa-search"></i></b-button>
              <b-button v-if="!row.item.selectionProcess && statusid === 1" v-b-tooltip.hover title="Add to selection process" variant="primary" size="xs" class="ml-1" @click="addCurriculum(row.item)"><i class="fas fa-plus-circle"></i></b-button>
              <i v-if="row.item.selectionProcess && statusid === 1" v-b-tooltip.hover class="fas fa-info-circle ml-1" title="This CV is already linked to another selection process."></i>
              <i v-if="statusid !== 1" v-b-tooltip.hover class="fas fa-info-circle ml-1" title="Not allowed to add CV due to status."></i>
            </template>
            <template v-slot:cell(name)="row">
              {{ row.item.candidate.name }} {{ row.item.candidate.surname }}
            </template>
            <template v-slot:cell(createdby)="row">
              {{ row.item.createdBy.name }} {{ row.item.createdBy.surname }}
            </template>
            <template v-slot:cell(createdat)="row">
              {{ row.item.createdAt | formatDateTime }}
            </template>
            <template v-slot:cell(updatedby)="row">
              {{ row.item.updatedBy.name }} {{ row.item.updatedBy.surname }}
            </template>
            <template v-slot:cell(updatedat)="row">
              {{ row.item.updatedAt | formatDateTime }}
            </template>
          </b-table>
          <b-pagination v-if="pageCount > 1" v-model="currentPage" size="md" :total-rows="totalItems" :per-page="perPage" class="d-flex justify-content-center"></b-pagination>
        </div>
      </div>
    </b-card>
	</div>
</template>

<script>
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import curriculum from '../curriculum/curriculum'
import 'vue-loading-overlay/dist/vue-loading.css'
var qs = require('qs')

export default {
  components: { loading, curriculum },
  props: {
    id: {
      type: String,
      required: true,
      default: '',
    },
    search: {
      type: Boolean,
      required: true,
      default: false,
    },
    statusid: {
      type: Number,
      required: true,
      default: 0,
    }
  },
  data() {
    return {
      curriculumItem: {},
      formSearch: {},
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      pageCount: 1,
      searchResult: [],
      searchResultFields: [
        {
          key: 'sequenceId',
          label: 'ID'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'createdby',
          label: 'Created By'
        },
        {
          key: 'createdat',
          label: 'Created At'
        },
        {
          key: 'updatedby',
          label: 'Last Updated By'
        },
        {
          key: 'updatedat',
          label: 'Last Updated At'
        },
        {
          key: 'edit',
          label: 'Options',
          thStyle: { 'word-wrap': 'break-word' },
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ]
    }
  },
  computed: {
    ...authComputed
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.currentPage = value
        this.searchAll()
      }
    },
    search: {
      handler: function (value) {
        this.searchAll()
      }
    }
  },
  created () {
    this.searchAll()
  },
  methods: {
    backSelectionProcessList () {
      this.$emit('callback', false)
    },
    viewCurriculum (item) {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'curriculum/' + item.id,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          this.curriculumItem = response.data
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.$refs['modalCurriculum'].show()
          this.isLoading = false
        })
    },
    hideModalCurriculum () {
      this.$refs['modalCurriculum'].hide()
    },
    searchAll () {
      this.isLoading = true
      axios.post(appConfig.apiUrl + 'selection-process/cvs-avaibles',
        qs.stringify({
          filtros: {
            pageNumber: this.currentPage,
            pageSize: this.perPage,
            filter: this.formSearch,
            ongoing: this.ongoing,
            deleted: false
          },
          selectionProcessId: this.id
        }),
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.currentPage = response.data.currentPage
          this.perPage = response.data.pageSize
          this.totalItems = response.data.rowCount
          this.searchResult = response.data.results
          this.pageCount = response.data.pageCount
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    addCurriculum (item) {
      this.$bvModal.msgBoxConfirm(`Do you really want to add curriculum the selection process?`, {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.saveAdd(item)
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    saveAdd (item) {
      axios.get(`${appConfig.apiUrl}selection-process/${this.id}/add-curriculum/${item.id}`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.searchAll()
        this.$emit('loadTable', null)
        this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Save Successful.'});
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      });
    }
  }
}
</script>